import { render, staticRenderFns } from "./commBaseCodeManage.vue?vue&type=template&id=2a69beeb&scoped=true&"
import script from "./commBaseCodeManage.vue?vue&type=script&lang=js&"
export * from "./commBaseCodeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69beeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a69beeb')) {
      api.createRecord('2a69beeb', component.options)
    } else {
      api.reload('2a69beeb', component.options)
    }
    module.hot.accept("./commBaseCodeManage.vue?vue&type=template&id=2a69beeb&scoped=true&", function () {
      api.rerender('2a69beeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/commBaseCodeManage/commBaseCodeManage.vue"
export default component.exports